var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-app flex-row align-items-center"},[_c('CContainer',{staticClass:"col-md-7"},[_c('CRow',{staticClass:"justify-content-center"},[_c('CCol',{attrs:{"md":"8"}},[_c('CCardGroup',[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view',{key:_vm.$route.path})],1)],1)],1)],1)],1),_c('LoginRight')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }